import {SortOrder} from '@hconnect/common/types'

export function getKeyByValue<T extends string, K>(object: {[key in T]: K}, value: K): T {
  return Object.keys(object).find((key) => object[key] === value) as T
}

const sortMapping: {
  [key in SortOrder]: 'asc' | 'desc'
} = {
  [SortOrder.Ascending]: 'asc',
  [SortOrder.Descending]: 'desc'
}

export const getSortDirection = (sortOrder?: SortOrder) => {
  return sortOrder ? sortMapping[sortOrder] : undefined
}

export const getSortOrder = (sortDir?: 'asc' | 'desc'): SortOrder | undefined => {
  return sortDir ? getKeyByValue<SortOrder, 'asc' | 'desc'>(sortMapping, sortDir) : undefined
}
